import { useLang, ui, tx } from "../i18n";
import { Icon } from "./Icon";

export const TABS = [
  { id: "clima", icon: "CloudSun" },
  { id: "directorio", icon: "PhoneCall" },
  { id: "checklists", icon: "CheckCircle2" },
  { id: "evacuacion", icon: "Route" },
  { id: "agua", icon: "Droplets" },
  { id: "energia", icon: "Zap" },
  { id: "cuidados", icon: "HeartPulse" },
  { id: "huertos", icon: "Sprout" },
  { id: "preguntas", icon: "CircleHelp" },
  { id: "sobre", icon: "Info" },
];

export function TabNav({ active, onChange }) {
  const { lang } = useLang();
  return (
    <nav
      data-testid="tab-nav"
      className="no-print sticky top-16 z-30 bg-white/95 backdrop-blur-xl border-b border-slate-300"
      aria-label="Secciones principales"
    >
      <div className="px-4 sm:px-8 lg:px-12">
        <div className="flex gap-1 overflow-x-auto no-scrollbar -mb-px">
          {TABS.map((t) => {
            const isActive = active === t.id;
            return (
              <button
                key={t.id}
                data-testid={`tab-${t.id}`}
                onClick={() => onChange(t.id)}
                aria-current={isActive ? "page" : undefined}
                className={`flex items-center gap-2 whitespace-nowrap px-3 sm:px-4 py-3.5 text-sm font-bold border-b-[3px] transition-colors duration-200 ${
                  isActive
                    ? "border-amber-600 text-red-800"
                    : "border-transparent text-red-700 hover:text-red-900 hover:border-red-300 hover:bg-red-50"
                }`}
              >
                <Icon name={t.icon} className={`w-[18px] h-[18px] ${isActive ? "text-red-800" : "text-red-600"}`} />
                {tx(ui.tabs[t.id], lang)}
              </button>
            );
          })}
        </div>
      </div>
    </nav>
  );
}
